import React from 'react';
import styled from 'styled-components';
import TopNavbar from '../../Nav/TopNavbar';
import Footer from '../Footer';

import { useTranslation } from 'react-i18next';
import { Trans } from 'react-i18next';
import ShareSidebar from './ShareSidebar';
import { Helmet } from 'react-helmet';

const BlogInstallCITRIN = () => {
    const { t } = useTranslation();

    const containerStyle: React.CSSProperties = {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        minHeight: '100vh',
    };
    return (
        <>
            <Helmet>
                <title>{t('titleUseCITRIN')}</title>
                <meta property="og:title" content={t('titleUseCITRIN')} />
                <meta property="og:image" content={require('../../../assets/img/WomanIntheCar.jpg')} />
                <meta property="og:description" content={t('blog.intro.urbanMobility')} />
            </Helmet>

            <ShareSidebar
                title={t('titleUseCITRIN')}
                media={require('../../../assets/img/WomanIntheCar.jpg')}
                url={`https://citrin-mobility.com/blog/how-to-use-citrin`}
                hashtags={['#citrin', '#mobility', '#transport']}
            />

            <div style={containerStyle}>
                <TopNavbar />
                <Wrapper id="how-to-use-citrin">
                    <Container>
                        <Meta>{t('blog.metaUseCITRIN')}</Meta>
                        <Title>{t('titleUseCITRIN')}</Title>
                        <ImgWrapperTitle>
                            <img src={require('../../../assets/img/WomanIntheCar.jpg')} alt="Woman in the car" />
                        </ImgWrapperTitle>

                        <Intro>
                            <p>{t('blog.intro.urbanMobility')}</p>
                            <p>{t('blog.intro.firstUserExperience')}</p>
                            <p>{t('blog.intro.guide')}</p>
                        </Intro>

                        <Section>
                            <h2>{t('blog.install.title')}</h2>
                            <Checklist>
                                <li>{t('blog.install.step.playstore')}</li>
                                <li>{t('blog.install.step.search')}</li>
                                <li>{t('blog.install.step.openApp')}</li>
                                <li>
                                    {t('blog.install.step.phoneLogin')}
                                    <ul>
                                        <li>{t('blog.install.step.verifySMS')}</li>
                                        <li>{t('blog.install.step.fillInfo')}</li>
                                        <li>{t('blog.install.step.terms')}</li>
                                        <li>{t('blog.install.step.success')}</li>
                                    </ul>
                                </li>
                            </Checklist>
                        </Section>

                        <Section>
                            <h2>{t('blog.location.title')}</h2>
                            <p>{t('blog.location.text')}</p>
                            <ImgWrapper>
                                <img src={require('../../../assets/img/manIntheTaxi.jpg')} alt="Man in the taxi" />
                            </ImgWrapper>
                        </Section>

                        <Section>
                            <h2>{t('blog.rideRequest.title')}</h2>
                            <NumberedChecklist>
                                <li>
                                    <span className="number">1.</span> {t('blog.rideRequest.step.pickupDestination')}
                                </li>
                                <li>
                                    <span className="number">2.</span> {t('blog.rideRequest.step.reviewOffers')}
                                </li>
                                <li>
                                    <span className="number">3.</span> {t('blog.rideRequest.step.acceptOffer')}
                                </li>
                                <li>
                                    <span className="number">4.</span> {t('blog.rideRequest.step.waitDriver')}
                                </li>
                                <li>
                                    <span className="number">5.</span> {t('blog.rideRequest.step.verifyCar')}
                                    <ul>
                                        <li>{t('blog.rideRequest.step.verifyCar1')}</li>
                                        <li>{t('blog.rideRequest.step.verifyCar2')}</li>
                                    </ul>
                                </li>
                                <li>
                                    <span className="number">6.</span> {t('blog.rideRequest.step.pay')}
                                </li>
                            </NumberedChecklist>
                        </Section>

                        <Section>
                            <h2>{t('blog.safety.title')}</h2>
                            <TipBlock>
                                <strong>{t('blog.safety.tip.checkRide.title')}</strong>
                                {t('blog.safety.tip.checkRide.text')}
                            </TipBlock>
                            <TipBlock>
                                <strong>{t('blog.safety.tip.rateTrip.title')}</strong>
                                {t('blog.safety.tip.rateTrip.text')}
                            </TipBlock>
                        </Section>
                        <ImgWrapper>
                            <img src={require('../../../assets/img/womanSittingCar.jpg')} alt="womanSittingCar" />
                        </ImgWrapper>
                        <Section>
                            <h2>{t('blog.promo.title')}</h2>
                            <Checklist>
                                <li>{t('blog.promo.step.openApp1')}</li>
                                <li>{t('blog.promo.step.openApp2')}</li>
                                <li>
                                    <Trans i18nKey="blog.promo.step.navigate" components={{ strong: <strong /> }} />
                                </li>
                                <li>
                                    <Trans i18nKey="blog.promo.step.enterCode" components={{ strong: <strong /> }} />
                                </li>
                            </Checklist>
                            <p>{t('blog.promo.success')}</p>
                            <h4>{t('blog.promo.closing')}</h4>
                        </Section>

                        <Section>
                            <p className="font15 greyColor font20">
                                <em>{t('blog.postedBy')}</em>
                            </p>
                        </Section>
                    </Container>
                </Wrapper>
                <Footer />
            </div>
        </>
    );
};

export default BlogInstallCITRIN;

// -------------------- STYLED COMPONENTS --------------------

const Wrapper = styled.section`
    background: #fff;
    padding: 60px 0;

    @media (max-width: 600px) {
        padding: 40px 12px;
    }
`;

const Container = styled.div`
    max-width: 800px;
    margin: 0 auto;
    padding: 0 24px;

    @media (max-width: 600px) {
        padding: 0 12px;
    }
`;

const Meta = styled.p`
    font-size: 14px;
    color: #666;
    margin-bottom: 32px;
    text-align: center;

    @media (max-width: 600px) {
        margin-bottom: 20px;
    }
`;

const ImgWrapperTitle = styled.div`
    width: 100vw;
    margin: 32px calc(-50vw + 50%);
    display: flex;
    justify-content: center;

    img {
        width: 1000px;
        max-width: 100%;
        height: 480px;
        object-fit: cover;
        border-radius: 12px;

        @media (max-width: 600px) {
            height: auto;
            width: 100%;
            border-radius: 8px;
        }
    }
`;

const Title = styled.h1`
    font-size: 44px;
    font-weight: 700;
    margin-bottom: 8px;
    color: #000;

    @media (max-width: 600px) {
        font-size: 28px;
        text-align: center;
    }
`;

const Intro = styled.div`
    font-size: 17px;
    color: #333;
    line-height: 1.7;
    margin-bottom: 40px;

    p {
        margin-bottom: 20px;
    }

    @media (max-width: 600px) {
        font-size: 15px;
        margin-bottom: 30px;
    }
`;

const Section = styled.section`
    margin-bottom: 48px;

    h2 {
        font-size: 25px;
        font-weight: 600;
        margin-bottom: 16px;
        color: #111;

        @media (max-width: 600px) {
            font-size: 20px;
        }
    }

    p {
        font-size: 16px;
        color: #444;
        line-height: 1.7;
        margin-bottom: 16px;

        @media (max-width: 600px) {
            font-size: 14px;
        }
    }
`;

const Checklist = styled.ol`
    list-style-type: disc;
    padding-left: 1.5em;
    margin-top: 16px;

    li {
        margin-bottom: 12px;
        font-size: 16px;
        color: #333;
        line-height: 1.7;

        @media (max-width: 600px) {
            font-size: 14px;
            margin-bottom: 10px;
        }
    }

    ul {
        list-style-type: circle;
        padding-left: 1.5em;
        margin-top: 8px;
    }

    ul li {
        margin-bottom: 8px;
        font-size: 16px;

        @media (max-width: 600px) {
            font-size: 14px;
        }
    }
`;

const ImgWrapper = styled.div`
    display: flex;
    justify-content: center;
    margin: 32px 0;

    img {
        width: 1000px;
        max-width: 100%;
        height: 480px;
        border-radius: 12px;

        @media (max-width: 600px) {
            height: auto;
            width: 100%;
            border-radius: 8px;
        }
    }
`;

const TipBlock = styled.div`
    background-color: #f4f8fb;
    border-left: 5px solid #0077cc;
    padding: 16px;
    margin-bottom: 24px;
    font-size: 16px;
    line-height: 1.7;
    color: #333;
    border-radius: 6px;

    strong {
        display: block;
        margin-bottom: 8px;
        color: #000;
    }

    @media (max-width: 600px) {
        font-size: 14px;
        padding: 12px;
        margin-bottom: 20px;
    }
`;
const NumberedChecklist = styled.ol`
    padding-left: 1.2rem;

    li {
        margin-bottom: 0.75rem;
        font-size: 1rem;
        line-height: 1.6;
    }

    .number {
        font-weight: bold;
        margin-right: 0.4rem;
    }

    ul {
        margin-top: 0.5rem;
        margin-left: 1.5rem;
        list-style-type: disc;

        li {
            font-weight: normal;
            font-size: 0.95rem;
            margin-bottom: 0.3rem;
        }
    }
`;
